import {
  getParentTraitReferences,
  getParentTraitsFromTemplate,
  getTraitEnrichmentReferences,
  getTraitEnrichmentReferencesLegacy,
  getTraitEnrichmentsFromTemplate,
  getTraitEnrichmentsFromTemplateLegacy,
} from "@hightouch/lib/query/visual/sync-transform/trait-template-helpers";

// Replaces trait references (trait_enrichments['alias'] and traits['name:uuid'])
// with their corresponding row keys (row["alias_XXXXXX"]) so the preview matches
// what the sync engine materializes. Shared by the Test and Migrate tester modes.
function traitAliasReplacer(
  tokens: string[],
  getRef: (token: string) => string | undefined,
  traitRowKeys: Record<string, string>,
  template: string,
): string {
  let result = template;
  for (const token of tokens) {
    const ref = getRef(token);
    if (ref === undefined) {
      continue;
    }
    const rowKey = traitRowKeys[ref];
    if (rowKey === undefined) {
      continue;
    }
    result = result.replaceAll(token, `row["${rowKey}"]`);
  }
  return result;
}

export function preprocessAudienceTraits(
  template: string,
  traitRowKeys: Record<string, string>,
): string {
  let result = traitAliasReplacer(
    getTraitEnrichmentsFromTemplate(template),
    (t) => getTraitEnrichmentReferences(t)[0],
    traitRowKeys,
    template,
  );
  result = traitAliasReplacer(
    getParentTraitsFromTemplate(result),
    (t) => getParentTraitReferences(t)[0],
    traitRowKeys,
    result,
  );
  result = traitAliasReplacer(
    getTraitEnrichmentsFromTemplateLegacy(result),
    (t) => getTraitEnrichmentReferencesLegacy(t)[0],
    traitRowKeys,
    result,
  );
  return result;
}
